module.exports = __webpack_public_path__ + "static/media/set_expectations.05c6db27.png";